import React from "react";
import "./App.css";
import Header from "./components/landing/Header";
import Hero from "./components/landing/Hero";
import USPSection from "./components/landing/USPSection";
import ServicesSection from "./components/landing/ServicesSection";
import GallerySection from "./components/landing/GallerySection";
import AboutSection from "./components/landing/AboutSection";
import PressSection from "./components/landing/PressSection";
import ContactSection from "./components/landing/ContactSection";
import Footer from "./components/landing/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <USPSection />
        <ServicesSection />
        <GallerySection />
        <AboutSection />
        <PressSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
